import {
	viewport,
} from '@tma.js/sdk'
import {
	useEffect,
} from 'react'

/**
 * - --tg-viewport-height
 * - --tg-viewport-width
 * - --tg-viewport-stable-height
 * - --tg-safe-area-inset-top
 * - --tg-safe-area-inset-bottom
 * - --tg-safe-area-inset-left
 * - --tg-safe-area-inset-right
 * - --tg-content-safe-area-inset-top
 * - --tg-content-safe-area-inset-bottom
 * - --tg-content-safe-area-inset-left
 * - --tg-content-safe-area-inset-right
 */
export const useTelegramViewport = (): void => {
	useEffect(() => {
		let unsubscribeSafeArea: (() => void) | undefined
		let unsubscribeContentSafeArea: (() => void) | undefined

		const initViewport = async(): Promise<void> => {
			try {
				if (!viewport.mount.isAvailable()) {
					setFallbackCssVariables()

					return
				}

				await viewport.mount()

				if (viewport.expand.isAvailable()) {
					viewport.expand()
				}

				if (viewport.bindCssVars.isAvailable()) {
					viewport.bindCssVars()
				}

				updateSafeAreaCssVars()

				unsubscribeSafeArea = viewport.safeAreaInsets.sub(updateSafeAreaCssVars)
				unsubscribeContentSafeArea = viewport.contentSafeAreaInsets.sub(updateSafeAreaCssVars)
			}
			// eslint-disable-next-line
			catch(error) {
				setFallbackCssVariables()
			}
		}

		initViewport()

		return (): void => {
			unsubscribeSafeArea?.()
			unsubscribeContentSafeArea?.()
		}
	}, [])
}

const updateSafeAreaCssVars = (): void => {
	const root = document.documentElement

	const safeArea = viewport.safeAreaInsets()

	root.style.setProperty('--tg-safe-area-inset-top', `${String(safeArea.top)}px`)
	root.style.setProperty('--tg-safe-area-inset-bottom', `${String(safeArea.bottom)}px`)
	root.style.setProperty('--tg-safe-area-inset-left', `${String(safeArea.left)}px`)
	root.style.setProperty('--tg-safe-area-inset-right', `${String(safeArea.right)}px`)

	const contentSafeArea = viewport.contentSafeAreaInsets()

	root.style.setProperty('--tg-content-safe-area-inset-top', `${String(contentSafeArea.top)}px`)
	root.style.setProperty('--tg-content-safe-area-inset-bottom', `${String(contentSafeArea.bottom)}px`)
	root.style.setProperty('--tg-content-safe-area-inset-left', `${String(contentSafeArea.left)}px`)
	root.style.setProperty('--tg-content-safe-area-inset-right', `${String(contentSafeArea.right)}px`)
}

const setFallbackCssVariables = (): void => {
	const root = document.documentElement

	root.style.setProperty('--tg-safe-area-inset-top', '0px')
	root.style.setProperty('--tg-safe-area-inset-bottom', '0px')
	root.style.setProperty('--tg-safe-area-inset-left', '0px')
	root.style.setProperty('--tg-safe-area-inset-right', '0px')

	root.style.setProperty('--tg-content-safe-area-inset-top', '0px')
	root.style.setProperty('--tg-content-safe-area-inset-bottom', '0px')
	root.style.setProperty('--tg-content-safe-area-inset-left', '0px')
	root.style.setProperty('--tg-content-safe-area-inset-right', '0px')
}
